export interface ILoginDetail {
  loginStrategy: loginStrategyType;
  redirectRules: redirectRule[];
  isDirectPV?: boolean;
  isK8S?: boolean;
  navigateFrom?: string;
  navigateTo?: string;
}

export interface redirectRule {
  redirect?: string;
  displayName?: string;
}

export enum loginStrategyType {
  unknown = "unknown",
  undefined = "undefined",
  form = "form",
  redirect = "redirect",
  serviceAccount = "service-account",
  redirectServiceAccount = "redirect-service-account",
}
